var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "kirmizi-santral-extensions" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "plus" },
                on: {
                  click: function ($event) {
                    _vm.showAddModal = true
                  },
                },
              },
              [_vm._v(" Dahili Ekle ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { icon: "reload", loading: _vm.loading },
                on: { click: _vm.refreshExtensions },
              },
              [_vm._v(" Yenile ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.extensions,
              loading: _vm.loading,
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showAddModal || _vm.showEditModal,
            title: _vm.showAddModal ? "Dahili Ekle" : "Dahili Düzenle",
            confirmLoading: _vm.saving,
          },
          on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "Dahili Numarası", required: "" } },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "Örn: 1001",
                      disabled: _vm.showEditModal,
                    },
                    model: {
                      value: _vm.currentExtension.extension,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentExtension, "extension", $$v)
                      },
                      expression: "currentExtension.extension",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Görünen Ad", required: "" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Dahili görünen adını girin" },
                    model: {
                      value: _vm.currentExtension.displayname,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentExtension, "displayname", $$v)
                      },
                      expression: "currentExtension.displayname",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Şifre", required: "" } },
                [
                  _c("a-input-password", {
                    attrs: { placeholder: "Dahili şifresi" },
                    model: {
                      value: _vm.currentExtension.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentExtension, "password", $$v)
                      },
                      expression: "currentExtension.password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Kodekler" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Örn: g729,alaw,ulaw" },
                    model: {
                      value: _vm.currentExtension.codecs,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentExtension, "codecs", $$v)
                      },
                      expression: "currentExtension.codecs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Kayıt" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.currentExtension.recordings,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentExtension, "recordings", $$v)
                        },
                        expression: "currentExtension.recordings",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "yes" } }, [
                        _vm._v("Evet"),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "no" } }, [
                        _vm._v("Hayır"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "WebRTC" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.currentExtension.webrtc,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentExtension, "webrtc", $$v)
                        },
                        expression: "currentExtension.webrtc",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "yes" } }, [
                        _vm._v("Evet"),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "no" } }, [
                        _vm._v("Hayır"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Sesli Mesaj" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.currentExtension.voicemail,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentExtension, "voicemail", $$v)
                        },
                        expression: "currentExtension.voicemail",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "yes" } }, [
                        _vm._v("Evet"),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "no" } }, [
                        _vm._v("Hayır"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Dahili Sil", confirmLoading: _vm.deleting },
          on: {
            ok: _vm.confirmDelete,
            cancel: function ($event) {
              _vm.showDeleteModal = false
            },
          },
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("p", [_vm._v("Bu dahiliyi silmek istediğinize emin misiniz?")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$_.get(_vm.deletingExtension, "extension")) +
                  " -\n                " +
                  _vm._s(_vm.$_.get(_vm.deletingExtension, "displayname"))
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Dahililer")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kırmızı Santral telefon dahililerini yönetin")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }